import { render, staticRenderFns } from "./VTelField.vue?vue&type=template&id=071fe4c3&scoped=true"
import script from "./VTelField.vue?vue&type=script&lang=js"
export * from "./VTelField.vue?vue&type=script&lang=js"
import style0 from "../assets/sprite.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VTelField.vue?vue&type=style&index=1&id=071fe4c3&prod&lang=scss"
import style2 from "./VTelField.vue?vue&type=style&index=2&id=071fe4c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071fe4c3",
  null
  
)

export default component.exports